var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78943 1.72583C2.44203 1.72583 2.1604 2.00746 2.1604 2.35486V8.64515C2.1604 8.99255 2.44203 9.27418 2.78943 9.27418H9.70875C10.0562 9.27418 10.3378 8.99255 10.3378 8.64515V2.35486C10.3378 2.00746 10.0562 1.72583 9.70875 1.72583H2.78943ZM11.5958 4.27768V2.35486C11.5958 1.31265 10.751 0.467773 9.70875 0.467773H2.78943C1.74722 0.467773 0.902344 1.31265 0.902344 2.35486V8.64515C0.902344 9.68736 1.74722 10.5322 2.78943 10.5322H9.70875C10.751 10.5322 11.5958 9.68736 11.5958 8.64515V6.72233L15.0044 9.15701C15.1961 9.29396 15.4483 9.31228 15.6578 9.20446C15.8674 9.09664 15.999 8.88077 15.999 8.64515V2.35486C15.999 2.11923 15.8674 1.90337 15.6578 1.79555C15.4483 1.68773 15.1961 1.70604 15.0044 1.843L11.5958 4.27768ZM12.049 5.5L14.741 7.42283V3.57718L12.049 5.5Z",
    fill: "#8BD8BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/video-chat.552c3cb55174565522b7f0de59faeb6e.svg";
export { ForwardRef as ReactComponent };